import { c as _c } from "react/compiler-runtime";
import { PAGE_TITLE_ID } from '@onefootprint/ui';
import { useEffect, useRef, useState } from 'react';
type UseDynamicTitleOptions = {
  containerId: string;
  headerRef: React.RefObject<HTMLDivElement | null>;
};
const getSandboxBannerHeight = (): number => {
  const sandboxBanner = document.querySelector('[data-testid="sandbox-banner"]');
  return sandboxBanner ? sandboxBanner.getBoundingClientRect().height : 0;
};
export const useDynamicTitle = t0 => {
  const $ = _c(4);
  const {
    containerId,
    headerRef
  } = t0;
  const [title, setTitle] = useState();
  const observerRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== containerId || $[1] !== headerRef) {
    t1 = () => {
      const setupObserver = () => {
        const titleElement = document.getElementById(PAGE_TITLE_ID);
        const container = document.getElementById(containerId);
        const header = headerRef.current;
        if (!titleElement || !container || !header) {
          return false;
        }
        observerRef.current?.disconnect();
        const headerHeight = header.getBoundingClientRect().height;
        const sandboxBannerHeight = getSandboxBannerHeight();
        const totalOffset = headerHeight + sandboxBannerHeight;
        let lastIsIntersecting = null;
        observerRef.current = new IntersectionObserver(entries => {
          const [entry] = entries;
          if (!document.body.contains(entry.target)) {
            return;
          }
          const wasNull = lastIsIntersecting === null;
          if (entry.isIntersecting === lastIsIntersecting) {
            return;
          }
          lastIsIntersecting = entry.isIntersecting;
          if (entry.isIntersecting) {
            setTitle(undefined);
          } else {
            setTitle(document.getElementById(PAGE_TITLE_ID)?.innerText);
          }
          if (!wasNull) {
            observerRef.current?.disconnect();
            requestAnimationFrame(() => {
              setupObserver();
            });
          }
        }, {
          root: container,
          threshold: 0,
          rootMargin: `-${totalOffset}px 0px 0px 0px`
        });
        observerRef.current.observe(titleElement);
        return true;
      };
      if (setupObserver()) {
        return () => observerRef.current?.disconnect();
      }
      const mutationObserver = new MutationObserver(() => {
        if (setupObserver()) {
          mutationObserver.disconnect();
        }
      });
      mutationObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      return () => {
        mutationObserver.disconnect();
        observerRef.current?.disconnect();
      };
    };
    t2 = [containerId, headerRef];
    $[0] = containerId;
    $[1] = headerRef;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  return title;
};